import { combineReducers } from "redux";
import LoginReducer from "./LoginReducer";
import UserReducer from "./UserReducer";
import LayoutReducer from "./LayoutReducer";
import userData from "./userData.reducer";
import ExportReducer from "./ExportReducer";
import UserManagementReducer from "./UserManagementReducer";
import { filterReducerTraining } from "app/_pages/_healthSafetyEnvironment/TrainingManagement/Assign/ReducerForAssign";
import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
const appReducer = combineReducers({
  login: LoginReducer,
  user: UserReducer,
  layout: LayoutReducer,
  userData: userData,
  export: ExportReducer,
  filterReducerTraining,
  userManagement: UserManagementReducer,
});

const RootReducer = (state, action) => {
  if (action.type === USER_DATA_CONSTANT.DESTROY) state = undefined;

  return appReducer(state, action);
};

export default RootReducer;
